import React from 'react';
import { CssBaseline } from '@mui/material';
import SignIn from './SignIn';

function App() {
  return (
    <>
      <CssBaseline />
      <SignIn />
    </>
  );
}

export default App